import type { TutorialDetailMap } from '@/utils/tutorialTypes';

export const tutorialDetailsMt4ToolsTrading: TutorialDetailMap = {
  'mt4-add-indicator': {
    intro: [
      'อินดิเคเตอร์ช่วยยืนยันจังหวะเข้าและออก เพิ่มได้ทั้งจาก Navigator และเมนู Insert > Indicators โดยมีให้เลือก 30 ตัวในตัวโปรแกรม',
      'จำนวนที่มากไม่ได้แปลว่าดีขึ้น มือใหม่ที่ติดตั้งสิบตัวพร้อมกันมักจบด้วยการไม่กล้าตัดสินใจ เพราะสัญญาณขัดกันเอง',
    ],
    sections: [
      {
        heading: 'อินดิเคเตอร์ 4 หมวดใน MT4',
        paragraphs: [
          'MT4 แบ่งอินดิเคเตอร์เป็น Trend, Oscillators, Volumes และ Bill Williams โดย Trend จะวาดทับบนกราฟราคา ส่วน Oscillators จะแสดงในหน้าต่างย่อยด้านล่าง',
          'ตัวอย่างที่ใช้บ่อยคือ Moving Average กับ Parabolic SAR ในหมวด Trend และ RSI กับ Stochastic ในหมวด Oscillators ซึ่งเพียงพอต่อการเทรดจริง',
        ],
        bullets: [
          'Trend — วาดบนกราฟราคา เช่น Moving Average, Bollinger Bands',
          'Oscillators — อยู่ในหน้าต่างย่อย เช่น RSI, Stochastic',
          'Volumes — ดูปริมาณการซื้อขาย',
          'Bill Williams — กลุ่มอินดิเคเตอร์เชิงทฤษฎี ใช้เฉพาะทาง',
        ],
      },
      {
        heading: 'ขั้นตอนเพิ่มอินดิเคเตอร์',
        paragraphs: [
          'ไปที่ Insert > Indicators แล้วเลือกหมวดและชื่อที่ต้องการ หน้าต่างตั้งค่าจะเปิดขึ้นก่อนวางบนกราฟ ให้ตรวจ Period และระดับที่สำคัญก่อนกด OK',
          'ถ้าเพิ่มผ่าน Navigator ให้ลากชื่ออินดิเคเตอร์ไปวางบนกราฟ วิธีนี้แม่นกว่าเมื่อมีกราฟหลายหน้าต่าง เพราะไม่ต้องกังวลว่าจะไปลงผิดกราฟ',
        ],
        bullets: [
          'Insert > Indicators เลือกได้ครบทุกหมวด',
          'ตรวจ Period ก่อนกด OK ทุกครั้ง',
          'ลากจาก Navigator เมื่อมีหลายกราฟเปิดอยู่',
          'อินดิเคเตอร์ที่เพิ่มแล้วแก้ไขได้ด้วย Ctrl+I',
        ],
      },
      {
        heading: 'เริ่มจากจำนวนเท่าไรจึงเหมาะสม',
        paragraphs: [
          'คำแนะนำที่ใช้ได้จริงคือเริ่มจาก 1-2 ตัวที่เข้าใจหลักการจริง เช่น Moving Average 1 ตัวกับ RSI 1 ตัว เพราะทั้งสองตัวตอบคำถามต่างกันคือทิศทางกับความร้อนแรงของราคา',
          'ถ้าเพิ่มจนเกิน 4 ตัวบนกราฟเดียว พื้นที่กราฟจะเหลือน้อยลงราว 40% และทำให้อ่านแท่งเทียนได้ยากขึ้น',
        ],
        bullets: [
          'เริ่มจาก 1-2 ตัวที่เข้าใจหลักการ',
          'ไม่ควรเกิน 4 ตัวบนกราฟเดียว',
          'อินดิเคเตอร์ประเภทเดียวกันซ้ำ ๆ ให้ผลคล้ายกัน',
        ],
      },
      {
        heading: 'ข้อผิดพลาดที่พบบ่อย',
        paragraphs: [
          'ข้อผิดพลาดที่พบบ่อยคือเพิ่มอินดิเคเตอร์จากกรอบเวลาเล็กแล้วใช้ตัดสินใจบนกรอบใหญ่ ค่าที่เห็นจึงไม่สอดคล้องกับกราฟที่กำลังดูอยู่',
          'อีกจุดคือลบอินดิเคเตอร์ออกแต่ยังเหลือ Template เก่า ทำให้เปิดกราฟใหม่แล้วอินดิเคเตอร์กลับมาทุกครั้ง ให้จัดการที่ Template ด้วย',
        ],
        bullets: [
          'ตั้งค่าให้ตรงกับกรอบเวลาที่ใช้ตัดสินใจ',
          'ลบอินดิเคเตอร์ออกจาก Template ด้วย ไม่ใช่แค่จากกราฟ',
          'ถ้ากราฟหน่วง ให้ลดจำนวนอินดิเคเตอร์ก่อน',
        ],
      },
    ],
    faqs: [
      {
        q: 'ควรใช้อินดิเคเตอร์กี่ตัว',
        a: 'แนะนำ 2-3 ตัวที่ทำหน้าที่ต่างกัน เช่น ตัวบอกแนวโน้ม 1 ตัว และตัวบอกจังหวะ 1 ตัว',
        a2: 'เหตุผลเชิงตัวเลขคือ ถ้าใช้อินดิเคเตอร์ 5 ตัวที่มีความแม่นยำ 60% แต่มักให้สัญญาณขัดกันเอง คุณจะเจอสัญญาณที่ตรงกันเพียงราว 1 ใน 5 ครั้ง และพลาดโอกาสไปมากกว่าที่คิด การใช้ 2 ตัวที่เข้าใจจริงให้ผลลัพธ์ที่วัดผลได้ง่ายกว่า',
      },
      {
        q: 'อินดิเคเตอร์ที่ดีที่สุดคือตัวไหน',
        a: 'ไม่มีตัวที่ดีที่สุด เพราะแต่ละตัวตอบคำถามคนละแบบ ขึ้นกับว่าคุณต้องการวัดอะไร',
        a2: 'ถ้าต้องการวัดแนวโน้มให้ใช้ Moving Average, ถ้าวัดความร้อนแรงให้ใช้ RSI, ถ้าวัดความผันผวนให้ใช้ Bollinger Bands หรือ ATR สิ่งที่สำคัญกว่าตัวเลือกคือคุณทดสอบมันบนกราฟย้อนหลังอย่างน้อย 50-100 ไม้ก่อนใช้เงินจริง',
      },
      {
        q: 'เพิ่มอินดิเคเตอร์แล้วกราฟช้า ทำอย่างไร',
        a: 'ลดจำนวนอินดิเคเตอร์และจำนวนกราฟที่เปิดพร้อมกัน เพราะแต่ละตัวต้องคำนวณใหม่ทุกครั้งที่ราคาเปลี่ยน',
        a2: 'ถ้ายังหน่วง ให้ปิดกราฟที่ไม่ดูและลดกรอบเวลา M1 ที่กินทรัพยากรหนักที่สุด แพลตฟอร์ม MT4 ใช้แรมราว 300-600 MB ในสภาวะปกติ แต่ถ้าเปิด 10 กราฟพร้อมอินดิเคเตอร์ครบ อาจใช้เกิน 1.5 GB จนเริ่มกระตุก',
      },
    ],
  },
  'mt4-indicator-settings': {
    intro: [
      'ค่า Period และระดับ Overbought / Oversold ของอินดิเคเตอร์มีผลกับสัญญาณมากกว่าที่มือใหม่คิด ค่าเริ่มต้นไม่ใช่ค่าที่เหมาะกับทุกกรอบเวลา',
      'การตั้งค่าที่ดีคือการตั้งค่าที่คุณทดสอบซ้ำแล้วว่าอ่านง่ายและตรงกับสไตล์การเทรดของตัวเอง',
    ],
    sections: [
      {
        heading: 'เปิดหน้าต่างตั้งค่าอินดิเคเตอร์',
        paragraphs: [
          'ดับเบิลคลิกที่เส้นอินดิเคเตอร์บนกราฟ หรือกด Ctrl+I เพื่อเปิดรายการอินดิเคเตอร์ทั้งหมดบนกราฟนั้น แล้วเลือกตัวที่ต้องการกด Edit',
          'หน้าต่างตั้งค่าแบ่งเป็นแท็บ Inputs สำหรับค่าคำนวณ และแท็บ Colors สำหรับสีและความหนาของเส้น ซึ่งปรับได้แยกจากค่า Period',
        ],
        bullets: [
          'Ctrl+I เปิดรายการอินดิเคเตอร์บนกราฟ',
          'แท็บ Inputs ปรับค่า Period และระดับ',
          'แท็บ Colors ปรับสีและความหนาเส้น',
          'กด Reset เพื่อกลับค่าเริ่มต้นถ้าตั้งจนอ่านไม่ออก',
        ],
      },
      {
        heading: 'ค่า Period ควรตั้งเท่าไร',
        paragraphs: [
          'Moving Average ที่ใช้บ่อยคือ 20 สำหรับระยะสั้น 50 สำหรับระยะกลาง และ 200 สำหรับแนวโน้มหลัก บนกรอบ H1 ค่า 200 ครอบคลุมข้อมูลราว 8 วันทำการ',
          'RSI ค่าเริ่มต้น 14 ให้สัญญาณค่อนข้างนิ่ง ถ้าลดเหลือ 7 สัญญาณจะถี่ขึ้นราว 2 เท่าแต่มีสัญญาณหลอกมากขึ้นด้วย',
        ],
        bullets: [
          'MA 20 / 50 / 200 คือชุดที่ใช้กันแพร่หลาย',
          'RSI 14 เหมาะกับกรอบ H1 ขึ้นไป',
          'ค่าที่เล็กลง = สัญญาณไวขึ้นแต่หลอกง่ายขึ้น',
          'ทดสอบค่าใหม่บนกราฟย้อนหลังก่อนใช้จริง',
        ],
      },
      {
        heading: 'ระดับ Overbought / Oversold',
        paragraphs: [
          'ค่าเริ่มต้นของ RSI คือ 70 และ 30 ซึ่งหมายความว่าราคาอาจร้อนแรงเกินไปในแต่ละทิศ แต่ในตลาดที่มีแนวโน้มชัด ราคาอาจอยู่ในโซนนี้ได้นานหลายสิบแท่ง',
          'ถ้าเทรดในตลาดแนวโน้ม ให้ปรับเป็น 80 และ 20 เพื่อลดสัญญาณออกก่อนเวลา ซึ่งช่วยลดการออกออเดอร์เร็วเกินไปได้ราวครึ่งหนึ่ง',
        ],
        bullets: [
          'ตลาดไซด์เวย์ใช้ 70 / 30',
          'ตลาดมีแนวโน้มใช้ 80 / 20',
          'อย่าใช้ Overbought เป็นสัญญาณขายเดี่ยว ๆ',
        ],
      },
      {
        heading: 'ข้อผิดพลาดที่พบบ่อย',
        paragraphs: [
          'ข้อผิดพลาดที่พบบ่อยคือเปลี่ยนค่าไปเรื่อย ๆ จนไม่รู้ว่าอะไรได้ผล เพราะทุกครั้งที่เปลี่ยนคือการเริ่มนับหนึ่งใหม่',
          'อีกจุดคือตั้งค่าให้กราฟดูสวยแต่ไม่ได้ทดสอบกับออเดอร์จริง หากต้องการวัดผลให้จดค่าที่ใช้ไว้ในบันทึกการเทรดทุกครั้ง',
        ],
        bullets: [
          'อย่าเปลี่ยนค่าบ่อยเกินหนึ่งครั้งต่อเดือน',
          'จดค่าที่ใช้คู่กับผลลัพธ์ทุกไม้',
          'ค่าเริ่มต้นมักปลอดภัยกว่าการปรับตามความรู้สึก',
        ],
      },
    ],
    faqs: [
      {
        q: 'ค่าเริ่มต้นของอินดิเคเตอร์ใช้ได้เลยไหม',
        a: 'ใช้ได้ในระดับหนึ่ง โดยเฉพาะเมื่อเพิ่งเริ่ม เพราะค่าเริ่มต้นถูกออกแบบมาให้ไม่ไวเกินไป',
        a2: 'แต่ต้องรู้ว่าค่าเริ่มต้นอย่าง RSI 14 ถูก calibrate มาสำหรับกราฟรายวันเป็นหลัก เมื่อนำมาใช้บน M5 สัญญาณจะถี่เกินจริงราว 3-5 เท่า ถ้าเทรดกรอบเล็กกว่านั้นควรเพิ่ม Period ขึ้นหรือยอมรับว่าต้องกรองสัญญาณเพิ่ม',
      },
      {
        q: 'ทำไมค่า RSI บน MT4 ไม่เท่ากับเว็บอื่น',
        a: 'เพราะแต่ละที่ใช้ราคาปิดและจำนวนแท่งต่างกัน รวมถึงเวลาเปิดปิดแท่งที่อ้างอิงคนละเขตเวลา',
        a2: 'ความต่างมักอยู่ที่ 1-3 จุด ซึ่งไม่มีผลต่อการตัดสินใจ แต่ถ้าต่างเกิน 5 จุด ให้ตรวจว่าได้ตั้ง Period เท่ากันและดูกรอบเวลาเดียวกันหรือไม่ รวมถึงตรวจว่าโบรกเกอร์ใช้เวลาเซิร์ฟเวอร์เขตไหน เพราะแท่งเทียนจะปิดคนละเวลา',
      },
      {
        q: 'ปรับสีอินดิเคเตอร์แล้วไม่เห็นการเปลี่ยนแปลง',
        a: 'อาจแก้ผิดกราฟหรือผิดอินดิเคเตอร์เมื่อมีหลายตัวที่ชื่อคล้ายกัน',
        a2: 'ให้กด Ctrl+I แล้วดูรายการว่ามีอินดิเคเตอร์ชื่อเดียวกันกี่ตัว ถ้ามีซ้ำให้ลบตัวที่ไม่ต้องการออกก่อน เพราะบางครั้งการเพิ่มซ้ำทำให้เส้นซ้อนกันจนดูเหมือนสีไม่เปลี่ยน',
      },
    ],
  },
  'mt4-remove-indicator': {
    intro: [
      'ลบอินดิเคเตอร์ที่ไม่ใช้แล้วออก เพื่อให้กราฟอ่านง่ายและลดภาระการประมวลผลของโปรแกรม',
      'การลบทำได้ใน 2 คลิก แต่ถ้าลบแล้วยังกลับมาทุกครั้งที่เปิดกราฟใหม่ แปลว่ายังค้างอยู่ใน Template',
    ],
    sections: [
      {
        heading: 'สองวิธีลบอินดิเคเตอร์',
        paragraphs: [
          'วิธีแรกคือกด Ctrl+I เปิดรายการอินดิเคเตอร์บนกราฟ เลือกตัวที่ต้องการแล้วกด Delete ซึ่งเหมาะเมื่อมีหลายตัวและต้องการลบพร้อมกัน',
          'วิธีที่สองคือคลิกขวาที่เส้นอินดิเคเตอร์บนกราฟแล้วเลือก Delete Indicator ซึ่งเร็วกว่าเมื่อรู้ว่าตัวไหนต้องการลบ',
        ],
        bullets: [
          'Ctrl+I > เลือก > Delete สำหรับลบหลายตัว',
          'คลิกขวาที่เส้น > Delete Indicator สำหรับลบทีละตัว',
          'ลบอินดิเคเตอร์ในหน้าต่างย่อยต้องคลิกที่หน้าต่างนั้นก่อน',
        ],
      },
      {
        heading: 'ลบแล้วยังกลับมา เกิดจากอะไร',
        paragraphs: [
          'สาเหตุที่พบบ่อยที่สุดคือ Template ที่ผูกกับกราฟยังมีอินดิเคเตอร์ตัวนั้นอยู่ ทุกครั้งที่เปิดกราฟใหม่ MT4 จะโหลด Template เดิมกลับมา',
          'วิธีแก้คือลบอินดิเคเตอร์ออกจากกราฟ แล้วไปที่ Charts > Template > Save Template ทับชื่อเดิม เพื่อให้ Template ใหม่ไม่มีตัวนั้น',
        ],
        bullets: [
          'ลบจากกราฟก่อน แล้วบันทึก Template ทับ',
          'ตรวจว่ากราฟใหม่โหลด Template ชื่ออะไร',
          'ถ้าใช้หลายโปรไฟล์ ต้องแก้ทุกโปรไฟล์ที่ใช้',
        ],
      },
      {
        heading: 'ลบอินดิเคเตอร์ออกจากเครื่อง',
        paragraphs: [
          'ถ้าต้องการลบไฟล์อินดิเคเตอร์ออกจากโปรแกรมทั้งหมด ให้เปิด File > Open Data Folder แล้วไปที่ MQL4 > Indicators ลบไฟล์ .ex4 ของตัวนั้น',
          'หลังลบไฟล์ต้องรีสตาร์ต MT4 หนึ่งครั้ง รายการใน Navigator จึงจะอัปเดต และกราฟที่เคยใช้ตัวนั้นจะแสดงเฉพาะเส้นที่คำนวณไว้เดิม',
        ],
        bullets: [
          'ไฟล์อินดิเคเตอร์อยู่ใน MQL4 > Indicators',
          'ลบไฟล์แล้วต้องรีสตาร์ตโปรแกรม',
          'ควรสำรองไฟล์ก่อนลบถ้าอาจต้องใช้ภายหลัง',
        ],
      },
      {
        heading: 'ข้อควรระวัง',
        paragraphs: [
          'การลบอินดิเคเตอร์ไม่มีผลกับออเดอร์ที่เปิดอยู่ แต่ถ้าอินดิเคเตอร์นั้นใช้เป็นเงื่อนไขออกออเดอร์ คุณจะไม่เห็นสัญญาณนั้นอีก',
          'ถ้าใช้ Expert Advisor ที่พึ่งพาอินดิเคเตอร์บางตัว การลบออกอาจทำให้ EA ทำงานผิดพลาด ควรตรวจคู่มือก่อน',
        ],
        bullets: [
          'การลบไม่มีผลกับออเดอร์ที่เปิดอยู่',
          'ตรวจก่อนว่ามี EA พึ่งพาอินดิเคเตอร์ตัวนั้นหรือไม่',
          'ลบทีละตัวเพื่อให้รู้ว่าตัวไหนทำให้กราฟเปลี่ยน',
        ],
      },
    ],
    faqs: [
      {
        q: 'ลบอินดิเคเตอร์แล้วกราฟยังหน่วงอยู่',
        a: 'อาจไม่ได้เกิดจากอินดิเคเตอร์ แต่มาจากจำนวนกราฟที่เปิดพร้อมกันหรือกรอบเวลา M1 ที่กินทรัพยากรหนัก',
        a2: 'ให้ปิดกราฟที่ไม่ดูและลดกราฟ M1 ลง ถ้ายังช้าให้ตรวจว่าเครื่องเหลือแรมเท่าไร เพราะ MT4 ใช้แรมราว 300-600 MB ในสภาวะปกติ แต่ถ้าเปิดหลายกราฟพร้อมอินดิเคเตอร์ครบอาจใช้เกิน 1.5 GB จนเริ่มกระตุก',
      },
      {
        q: 'ลบอินดิเคเตอร์ผิดตัว กู้คืนได้ไหม',
        a: 'กู้คืนไม่ได้ แต่เพิ่มกลับได้ทันทีจาก Insert > Indicators โดยใช้ค่าเริ่มต้น',
        a2: 'ถ้าเคยตั้งค่าเองไว้และจำไม่ได้ ให้ดูจากกราฟอื่นที่ยังมีอินดิเคเตอร์ตัวนั้นอยู่ แล้วจดค่า Period ไว้ก่อนลบทุกครั้ง วิธีที่ปลอดภัยกว่าคือบันทึก Template สำรองไว้ ซึ่งเก็บค่าทั้งหมดของทุกอินดิเคเตอร์บนกราฟ',
      },
      {
        q: 'ทำไมคลิกขวาที่เส้นแล้วไม่มี Delete Indicator',
        a: 'เพราะคลิกไม่ตรงกับเส้น หรือเส้นนั้นเป็นวัตถุที่วาดด้วยมือไม่ใช่อินดิเคเตอร์',
        a2: 'ให้คลิกที่เส้นตรง ๆ หรือใช้ Ctrl+I ซึ่งเป็นวิธีที่แน่นอนกว่า ถ้าในรายการไม่มีชื่อนั้นเลย แปลว่าสิ่งที่เห็นเป็นเส้น trendline ที่วาดเอง ให้ใช้ Ctrl+B เปิด Objects List แล้วลบจากที่นั่นแทน',
      },
    ],
  },
  'mt4-open-order': {
    intro: [
      'การเปิดออเดอร์บน MT4 ใช้หน้าต่าง New Order ซึ่งต้องตรวจคู่เงิน ทิศทาง และขนาดล็อตให้ครบก่อนยืนยัน ใช้เวลาราว 15-30 วินาทีต่อไม้',
      'ทุกช่องในหน้าต่างนี้มีผลกับความเสี่ยงโดยตรง โดยเฉพาะ Volume และ Stop Loss ที่ควรกรอกก่อนกดปุ่ม Place',
    ],
    sections: [
      {
        heading: 'เปิดหน้าต่าง New Order',
        paragraphs: [
          'กด F9 หรือคลิกขวาที่กราฟแล้วเลือก Trading > New Order จะมีหน้าต่างสั่งซื้อขายขึ้นมา โดยระบบจะเลือกคู่เงินของกราฟที่กำลังดูอยู่ให้อัตโนมัติ',
          'ในหน้าต่างนี้มีสามส่วนหลักคือช่อง Symbol, ช่อง Volume และปุ่ม Buy กับ Sell ซึ่งราคาที่จะได้แสดงอยู่บนปุ่มทั้งสอง',
        ],
        bullets: [
          'F9 เปิดหน้าต่าง New Order ได้เร็วที่สุด',
          'ระบบเลือกคู่เงินตามกราฟที่เปิดอยู่ให้อัตโนมัติ',
          'ราคาบนปุ่ม Buy คือ Ask และบนปุ่ม Sell คือ Bid',
          'ตรวจ Market Order หรือ Instant Execution ก่อนยืนยัน',
        ],
      },
      {
        heading: 'กำหนดขนาดล็อตให้ตรงกับความเสี่ยง',
        paragraphs: [
          'ช่อง Volume ต้องกรอกเป็นล็อต ไม่ใช่จำนวนเงิน มาตรฐานคือ 1.00 Lot = 100,000 หน่วย ซึ่ง 1 Pip ของ EURUSD จะมีค่าประมาณ 10 ดอลลาร์',
          'ถ้าพอร์ต 1,000 ดอลลาร์และยอมเสี่ยง 1% ต่อไม้ เท่ากับ 10 ดอลลาร์ และตั้ง Stop Loss 20 Pip สูตรคือ 10 หารด้วย (20 คูณ 10) ได้ 0.05 Lot',
        ],
        bullets: [
          '1.00 Lot = 100,000 หน่วย',
          'EURUSD 1 Pip ≈ 10 ดอลลาร์ต่อ 1 Lot',
          'ขนาดล็อต = เงินที่ยอมเสีย ÷ (จำนวน Pip × มูลค่าต่อ Pip)',
          'ถ้าคำนวณไม่ได้ ให้ใช้ขนาดเล็กสุด 0.01 Lot ก่อน',
        ],
      },
      {
        heading: 'ตั้ง Stop Loss และ Take Profit ก่อนกดยืนยัน',
        paragraphs: [
          'กรอกช่อง Stop Loss และ Take Profit เป็นระดับราคา ไม่ใช่จำนวนเงิน และต้องห่างจากราคาปัจจุบันเกินระยะขั้นต่ำของคู่นั้น ซึ่งดูได้จากหน้าต่าง Specification',
          'ถ้ายังไม่แน่ใจจุดตัดขาดทุน ให้ยกเลิกแล้วกลับไปดูกราฟก่อน เพราะการเปิดออเดอร์โดยไม่มี Stop Loss เป็นสาเหตุอันดับหนึ่งของขาดทุนก้อนใหญ่',
        ],
        bullets: [
          'Stop Loss เป็นระดับราคา ไม่ใช่จำนวนเงิน',
          'ระยะขั้นต่ำของแต่ละคู่ไม่เท่ากัน',
          'ถ้าระยะไม่พอ ระบบจะขึ้น Invalid stops',
          'ควรตั้ง Stop Loss ทุกไม้โดยไม่มีข้อยกเว้น',
        ],
      },
      {
        heading: 'หลังกดยืนยันแล้วเกิดอะไรขึ้น',
        paragraphs: [
          'ถ้าสำเร็จ ออเดอร์จะไปปรากฏในแท็บ Trade ที่หน้าต่าง Terminal ด้านล่าง พร้อมราคาเข้าและผลกำไรขาดทุนที่อัปเดตตลอดเวลา',
          'ถ้าไม่สำเร็จจะมีข้อความแจ้งเตือน เช่น Requote หรือ Off quotes ซึ่งหมายถึงราคาเปลี่ยนเร็ว ให้ตรวจราคาใหม่แทนการกดยืนยันซ้ำทันที',
        ],
        bullets: [
          'ออเดอร์ใหม่จะอยู่บนสุดของแท็บ Trade',
          'Requote = ราคาเปลี่ยน ให้ตรวจใหม่',
          'Off quotes = ราคานอกช่วงที่อนุญาต มักเกิดตอนข่าว',
          'บันทึกเหตุผลที่เข้าไว้ในบันทึกการเทรดทันที',
        ],
      },
    ],
    faqs: [
      {
        q: 'เปิดออเดอร์ขั้นต่ำได้เท่าไร',
        a: 'ขึ้นกับโบรกเกอร์ ส่วนใหญ่เริ่มที่ 0.01 Lot หรือ 1,000 หน่วย ซึ่งคิดเป็นประมาณ 0.10 ดอลลาร์ต่อ Pip สำหรับ EURUSD',
        a2: 'ข้อจำกัดที่ต้องรู้คือบางโบรกเกอร์กำหนดขั้นต่ำ 0.10 Lot สำหรับบัญชีมาตรฐาน และบัญชี Micro อาจเริ่ม 0.01 Lot ถ้าพอร์ตเริ่มต้น 500 ดอลลาร์ การใช้ 0.01 Lot ทำให้เสี่ยงเพียง 0.10 ดอลลาร์ต่อ Pip ซึ่งเล็กพอจะฝึกได้โดยไม่เจ็บตัว',
      },
      {
        q: 'กด Buy แล้วราคาเข้าสูงกว่าที่เห็น ทำไม',
        a: 'เพราะ Buy เข้าที่ราคา Ask ซึ่งสูงกว่า Bid ที่แสดงบนกราฟอยู่แล้วหนึ่ง Spread และอาจมีสลิปเพจเพิ่มถ้าตลาดเคลื่อนไหวเร็ว',
        a2: 'ตัวอย่างเช่น กราฟแสดง 1.08540 แต่ Ask คือ 1.08552 แปลว่า Spread 1.2 Pip ถูกหักทันทีที่เปิดไม้ ถ้าเปิด 0.10 Lot ต้นทุนนี้ประมาณ 1.2 ดอลลาร์ ซึ่งต้องบวกเข้าไปในเป้ากำไรของคุณเสมอ',
      },
      {
        q: 'เปิดออเดอร์โดยไม่ตั้ง Stop Loss ได้ไหม',
        a: 'ทำได้ แต่ไม่แนะนำ เพราะความเสี่ยงจะไม่จำกัดและไม่มีจุดที่คุณต้องยอมรับผลขาดทุน',
        a2: 'วิธีที่ปลอดภัยคือตั้ง Stop Loss ทันทีหลังเปิดไม้ ถ้ายังไม่แน่ใจจุดตัดขาดทุน ให้ใช้ขนาด 0.01 Lot และตั้ง Stop Loss ห่าง 30-50 Pip ซึ่งจำกัดความเสี่ยงไว้ราว 3-5 ดอลลาร์ต่อไม้ เป็นระดับที่ผิดพลาดได้โดยไม่กระทบพอร์ต',
      },
    ],
  },
  'mt4-set-sl-tp': {
    intro: [
      'Stop Loss และ Take Profit คือสองช่องที่ควรกรอกทุกครั้งก่อนกดยืนยันคำสั่ง เพื่อจำกัดความเสี่ยงและล็อกกำไรไว้ล่วงหน้า',
      'ทั้งสองช่องกรอกเป็นระดับราคา ไม่ใช่จำนวนเงิน ซึ่งเป็นจุดที่มือใหม่กรอกผิดมากที่สุด',
    ],
    sections: [
      {
        heading: 'ความต่างระหว่าง Stop Loss กับ Take Profit',
        paragraphs: [
          'Stop Loss คือระดับราคาที่คุณยอมขาดทุนและออกจากออเดอร์อัตโนมัติ ส่วน Take Profit คือระดับที่คุณพอใจกับกำไรและปิดออเดอร์',
          'สำหรับ Buy นั้น Stop Loss จะอยู่ต่ำกว่าราคาเข้า และ Take Profit อยู่สูงกว่า ส่วน Sell จะกลับกัน ถ้ากรอกสลับทิศ ระบบจะขึ้น Invalid stops',
        ],
        bullets: [
          'Buy: SL ต่ำกว่าราคาเข้า, TP สูงกว่า',
          'Sell: SL สูงกว่าราคาเข้า, TP ต่ำกว่า',
          'กรอกเป็นระดับราคา เช่น 1.08200',
          'ระยะต้องห่างเกินขั้นต่ำของคู่นั้น',
        ],
      },
      {
        heading: 'คำนวณ Stop Loss จากเงินที่ยอมเสีย',
        paragraphs: [
          'อย่าตั้ง Stop Loss ตามความรู้สึก ให้คำนวณย้อนกลับจากเงินที่ยอมเสีย สูตรคือ จำนวน Pip ที่รับได้ = เงินที่ยอมเสีย ÷ (ขนาดล็อต × มูลค่าต่อ Pip)',
          'ตัวอย่าง พอร์ต 2,000 ดอลลาร์ เสี่ยง 1% คือ 20 ดอลลาร์ ถ้าเทรด 0.10 Lot บน EURUSD มูลค่า 1 ดอลลาร์ต่อ Pip จะรับได้ 20 Pip จึงตั้ง Stop Loss ห่าง 20 Pip จากราคาเข้า',
        ],
        bullets: [
          'คำนวณจากเงินที่ยอมเสีย ไม่ใช่จากระยะที่ดูสวย',
          '1% ของพอร์ตคือเพดานที่แนะนำสำหรับมือใหม่',
          'Stop Loss 20 Pip กับ 0.10 Lot = เสี่ยง 20 ดอลลาร์',
          'เขียนตัวเลขนี้ลงบันทึกก่อนกดยืนยัน',
        ],
      },
      {
        heading: 'ตั้ง Stop Loss หลังเปิดออเดอร์แล้ว',
        paragraphs: [
          'ถ้าเปิดออเดอร์ไปแล้วโดยไม่มี Stop Loss ให้คลิกขวาที่ออเดอร์ในแท็บ Trade แล้วเลือก Modify or Delete Order เพื่อเติมค่าทีหลัง',
          'ในหน้าต่างเดียวกันนี้ยังใช้เลื่อน Stop Loss ตามราคาได้ แต่ต้องเลื่อนไปในทิศที่ลดความเสี่ยงเท่านั้น ไม่ใช่เลื่อนออกเพื่อหนีการขาดทุน',
        ],
        bullets: [
          'คลิกขวาที่ออเดอร์ > Modify เพื่อแก้ไข',
          'เลื่อน Stop Loss ได้ในทิศที่ลดความเสี่ยงเท่านั้น',
          'หลังแก้ไขให้ตรวจว่าแสดงในแท็บ Trade แล้ว',
        ],
      },
      {
        heading: 'ข้อผิดพลาดที่พบบ่อย',
        paragraphs: [
          'ปัญหา Invalid stops เกิดจากระยะ Stop Loss ใกล้ราคาปัจจุบันเกินไป ซึ่งแต่ละคู่กำหนดไม่เท่ากัน คู่เงินหลักมักต้องการอย่างน้อย 10-20 Point',
          'อีกข้อคือตั้ง Take Profit ไกลเกินจริงโดยไม่มีเหตุผลเชิงกราฟ ทำให้ออเดอร์ค้างนานและถูกปิดด้วย Stop Loss ก่อน',
        ],
        bullets: [
          'Invalid stops = ระยะใกล้เกินไป',
          'ตั้ง TP ให้สอดคล้องกับแนวต้านแนวรับจริง',
          'อย่าเลื่อน Stop Loss ออกเพื่อหนีขาดทุน',
          'ตรวจทั้งสองช่องก่อนกดยืนยันทุกครั้ง',
        ],
      },
    ],
    faqs: [
      {
        q: 'Stop Loss ควรห่างกี่ Pip',
        a: 'ขึ้นกับความผันผวนของคู่เงินและกรอบเวลาที่เทรด ไม่มีตัวเลขเดียวที่ใช้ได้กับทุกสถานการณ์',
        a2: 'เกณฑ์ที่ใช้ได้จริงคือให้ Stop Loss อยู่เหนือหรือใต้ swing low / swing high ล่าสุดประมาณ 5-10 Pip บนกรอบ H1 ซึ่งมักได้ระยะ 20-40 Pip สำหรับคู่เงินหลัก ถ้าระยะที่ได้น้อยกว่า 15 Pip แปลว่าจุดเข้าอยู่ใกล้แนวมากเกินไปจนไม่น่าลงทุน',
      },
      {
        q: 'ตั้ง Take Profit ต้องใหญ่กว่า Stop Loss ไหม',
        a: 'ไม่จำเป็น แต่ต้องรู้ว่าถ้า TP เล็กกว่า SL ต้องชนะบ่อยขึ้นจึงจะไม่ขาดทุน',
        a2: 'ตัวเลขที่ช่วยได้คือ ถ้า TP 20 Pip และ SL 40 Pip คุณต้องชนะมากกว่า 67% จึงจะเท่าทุน ส่วน TP 40 กับ SL 20 ต้องการเพียง 34% เท่านั้น สำหรับมือใหม่ที่อัตราชนะราว 50% การตั้ง TP อย่างน้อยเท่ากับ SL จะปลอดภัยกว่ามาก',
      },
      {
        q: 'แก้ Stop Loss แล้วขึ้น Invalid stops ต้องทำอย่างไร',
        a: 'หมายถึงระยะที่ตั้งใกล้ราคาปัจจุบันเกินกว่าที่โบรกเกอร์อนุญาต ให้เลื่อนออกไปอีกเล็กน้อย',
        a2: 'วิธีตรวจระยะขั้นต่ำคือคลิกขวาที่คู่เงินใน Market Watch เลือก Specification แล้วดูหัวข้อ Stops level ซึ่งมักเป็น 0 หรือ 10-30 Point ถ้ายังไม่ผ่าน ให้เลื่อนออกไปอีก 5-10 Pip แล้วลองใหม่ อย่าลดขนาด Stop Loss เพื่อให้ระบบรับ เพราะนั่นคือการเพิ่มความเสี่ยง',
      },
    ],
  },
  'mt4-edit-close-order': {
    intro: [
      'แก้ไขจุด Stop Loss และ Take Profit หรือปิดสถานะบางส่วนได้จากแท็บ Trade โดยไม่ต้องเปิดออเดอร์ใหม่',
      'การปิดบางส่วนช่วยล็อกกำไรไว้บางส่วน แต่ต้องระวังขนาดที่เหลือต้องไม่ต่ำกว่าล็อตขั้นต่ำของคู่นั้น',
    ],
    sections: [
      {
        heading: 'หาเครื่องมือจัดการออเดอร์',
        paragraphs: [
          'เปิดแท็บ Trade ในหน้าต่าง Terminal ด้านล่าง จะเห็นออเดอร์ที่เปิดอยู่ทั้งหมดพร้อมราคาเข้า ราคาปัจจุบัน และผลกำไรขาดทุน',
          'คลิกขวาที่รายการเพื่อเลือก Modify or Delete Order สำหรับแก้ไข หรือ Close Order สำหรับปิดสถานะ ซึ่งเป็นสองคำสั่งที่ใช้บ่อยที่สุด',
        ],
        bullets: [
          'แท็บ Trade รวมออเดอร์ที่ยังเปิดอยู่',
          'คลิกขวา > Modify แก้ Stop Loss และ Take Profit',
          'คลิกขวา > Close Order ปิดสถานะ',
          'ดับเบิลคลิกที่ออเดอร์เปิดหน้าต่างแก้ไขได้เช่นกัน',
        ],
      },
      {
        heading: 'แก้ไข Stop Loss และ Take Profit',
        paragraphs: [
          'ในหน้าต่าง Modify Order ให้แก้ตัวเลขในช่อง Stop Loss หรือ Take Profit แล้วกด Modify ระบบจะใช้ค่าใหม่ทันทีถ้าระยะผ่านเงื่อนไข',
          'จุดที่ควรจำคือการแก้ไขไม่มีผลย้อนหลัง ออเดอร์ที่ปิดไปแล้วจะไม่ถูกแก้ และราคาที่ได้ยังเป็นราคาตลาด ณ ตอนปิด',
        ],
        bullets: [
          'แก้แล้วกด Modify เพื่อยืนยัน',
          'ระยะต้องห่างเกินขั้นต่ำของคู่เงิน',
          'การแก้ไขไม่มีผลกับออเดอร์ที่ปิดแล้ว',
        ],
      },
      {
        heading: 'ปิดออเดอร์บางส่วน',
        paragraphs: [
          'ในหน้าต่าง Close Order ให้แก้ช่อง Volume เป็นขนาดที่ต้องการปิด เช่นจาก 0.10 Lot ปิดไป 0.05 Lot แล้วกด Close',
          'ขนาดที่เหลือต้องไม่ต่ำกว่าล็อตขั้นต่ำของคู่นั้น ซึ่งโดยทั่วไปคือ 0.01 Lot ถ้าปิดจนเหลือน้อยกว่านั้น ระบบจะปิดทั้งหมดแทน',
        ],
        bullets: [
          'แก้ Volume ในหน้าต่าง Close เพื่อปิดบางส่วน',
          'ขนาดที่เหลือต้องไม่ต่ำกว่า 0.01 Lot',
          'การปิดบางส่วนจะเกิด Spread อีกครั้ง',
          'ควรปิดบางส่วนเมื่อราคาไปถึงเป้าแรก',
        ],
      },
      {
        heading: 'ข้อผิดพลาดที่พบบ่อย',
        paragraphs: [
          'ข้อผิดพลาดที่พบบ่อยคือพยายามปิดบางส่วนแต่ระบบปิดทั้งหมด เพราะขนาดที่เหลือต่ำกว่าขั้นต่ำ ซึ่งแก้ได้โดยปิดเป็นจำนวนที่ทำให้เหลืออย่างน้อย 0.01 Lot',
          'อีกกรณีคือกด Close แล้วราคาไม่ตรงกับที่เห็น เพราะราคาเปลี่ยนระหว่างกดยืนยัน ให้ตรวจราคาในหน้าต่าง Close ทุกครั้งก่อนกด',
        ],
        bullets: [
          'ตรวจขนาดคงเหลือก่อนปิดบางส่วน',
          'ราคาในหน้าต่าง Close อาจต่างจากกราฟเล็กน้อย',
          'ถ้า Requote ให้ตรวจราคาใหม่ ไม่ควรกดซ้ำเร็ว ๆ',
        ],
      },
    ],
    faqs: [
      {
        q: 'ปิดออเดอร์บางส่วนแล้วค่าคอมมิชชันคิดอย่างไร',
        a: 'โบรกเกอร์ส่วนใหญ่คิดค่าคอมมิชชันตามขนาดที่ปิดจริง ดังนั้นการปิดสองครั้งจะถูกคิดสองครั้ง',
        a2: 'ถ้าค่าคอมมิชชันอยู่ที่ 7 ดอลลาร์ต่อ 1 Lot การปิด 0.05 Lot สองครั้งจะเสียรวม 0.70 ดอลลาร์ เท่ากับปิดครั้งเดียว 0.10 Lot แต่ถ้าโบรกเกอร์คิดขั้นต่ำต่อออเดอร์ การปิดหลายครั้งอาจแพงกว่า ให้ตรวจตารางค่าธรรมเนียมก่อนตั้งแผนปิดทำกำไรเป็นขั้นบันได',
      },
      {
        q: 'ปิดออเดอร์แล้วแต่ยังเห็นค้างในแท็บ Trade',
        a: 'อาจยังไม่ได้รีเฟรช หรือออเดอร์นั้นถูกปิดบางส่วนและเหลือสถานะอยู่',
        a2: 'ให้ตรวจช่อง Volume ว่ายังเหลือเท่าไร ถ้าเหลือ 0.00 แปลว่าปิดหมดแล้วและระบบแค่ยังไม่อัปเดต ให้กดคลิกขวาแล้วเลือก Refresh อีกครั้ง ถ้ายังค้างให้ตรวจแท็บ Account History ว่ามีรายการปิดบันทึกไว้หรือไม่',
      },
      {
        q: 'ปิดบางส่วนแล้วเหลือ 0.005 Lot ได้ไหม',
        a: 'ไม่ได้ เพราะต่ำกว่าล็อตขั้นต่ำ ระบบจะปิดทั้งหมดแทนหรือปฏิเสธคำสั่ง',
        a2: 'ขนาดที่เล็กที่สุดที่ทำได้คือ 0.01 Lot สำหรับบัญชีส่วนใหญ่ ถ้าถือ 0.03 Lot และอยากปิดทีละส่วน ให้ปิด 0.01 สองครั้งแล้วเหลือ 0.01 ซึ่งยังใช้งานได้ ถ้าถือ 0.02 Lot จะปิดบางส่วนได้เพียงครั้งเดียว',
      },
    ],
  },
  'mt4-trade-history': {
    intro: [
      'ประวัติการเทรดช่วยให้เห็นผลลัพธ์จริงของแต่ละออเดอร์ และใช้ตรวจสอบค่าสวอปกับคอมมิชชันที่ถูกหักไป',
      'ข้อมูลนี้เป็นวัตถุดิบสำคัญของการทบทวนผลงาน เพราะความจำของคนเราเก็บได้ไม่ถึงครึ่งของสิ่งที่เกิดขึ้นจริง',
    ],
    sections: [
      {
        heading: 'เปิดประวัติการเทรด',
        paragraphs: [
          'เปิดแท็บ Account History ในหน้าต่าง Terminal ด้านล่าง ซึ่งจะแสดงเฉพาะออเดอร์ที่ปิดแล้ว ไม่รวมออเดอร์ที่ยังเปิดอยู่',
          'ถ้าไม่เห็นรายการ ให้คลิกขวาในช่วงว่างแล้วเลือก All History หรือเลือกช่วงเวลาที่ต้องการ เพราะค่าเริ่มต้นอาจกรองแค่เดือนปัจจุบัน',
        ],
        bullets: [
          'Account History แสดงเฉพาะออเดอร์ที่ปิดแล้ว',
          'คลิกขวา > All History เพื่อดูทั้งหมด',
          'เลือก Custom Period เพื่อกำหนดช่วงวันที่เอง',
          'ดับเบิลคลิกที่แถวเพื่อดูรายละเอียดค่าธรรมเนียม',
        ],
      },
      {
        heading: 'อ่านตัวเลขในประวัติให้เป็น',
        paragraphs: [
          'แต่ละแถวแสดงเวลาเปิด-ปิด คู่เงิน ทิศทาง ขนาดล็อต ราคาเข้า-ออก และผลลัพธ์เป็นตัวเงิน ซึ่งผลลัพธ์นี้หักค่าสวอปและคอมมิชชันแล้ว',
          'ถ้าต้องการดูว่าต้นทุนกินไปเท่าไร ให้ดับเบิลคลิกแถวนั้นแล้วดูรายละเอียด ซึ่งจะแยก Swap กับ Commission ออกมาชัดเจน',
        ],
        bullets: [
          'Profit ในประวัติคือยอดสุทธิหลังหักต้นทุนแล้ว',
          'Swap คือค่าถือข้ามคืน อาจเป็นบวกหรือลบ',
          'Commission คือค่าคอมมิชชันต่อล็อต',
          'ดูเวลาเปิด-ปิดเพื่อรู้ว่าถือไม้นานแค่ไหน',
        ],
      },
      {
        heading: 'บันทึกและส่งออกข้อมูล',
        paragraphs: [
          'คลิกขวารายการที่สนใจแล้วเลือก Save as Report เพื่อเก็บเป็นไฟล์ HTML ที่เปิดดูได้ในเบราว์เซอร์ และ Save as Detailed Report สำหรับไฟล์ที่มีรายละเอียดครบ',
          'ถ้าต้องการวิเคราะห์ในสเปรดชีต ให้ใช้ Save as Report แล้วคัดลอกตารางไปวาง ซึ่งใช้เวลาไม่ถึงหนึ่งนาทีต่อเดือน',
        ],
        bullets: [
          'Save as Report ได้ไฟล์ HTML เปิดดูง่าย',
          'Detailed Report มีรายละเอียดค่าธรรมเนียมครบ',
          'คัดลอกลงสเปรดชีตเพื่อวิเคราะห์ต่อได้',
          'เก็บไฟล์รายเดือนไว้เทียบผลลัพธ์ระยะยาว',
        ],
      },
      {
        heading: 'ข้อผิดพลาดที่พบบ่อย',
        paragraphs: [
          'ถ้าประวัติไม่ขึ้น ให้ตรวจว่ากรองช่วงวันที่อยู่ถูกช่วง และบัญชีที่ล็อกอินอยู่เป็นบัญชีที่เคยเทรดจริงหรือไม่ เพราะบัญชีทดลองแยกประวัติจากบัญชีจริง',
          'อีกกรณีคือเห็นแต่ตัวเลขกำไรขาดทุนรวมแต่ไม่เห็นค่าสวอป ให้เปิด Detailed Report ซึ่งแสดงรายละเอียดแยกทุกครั้ง',
        ],
        bullets: [
          'ตรวจตัวกรองวันที่ก่อนสรุปว่าประวัติหาย',
          'บัญชีทดลองและบัญชีจริงแยกประวัติกัน',
          'ถ้าเปลี่ยนเครื่อง ประวัติเดิมจะไม่ตามมา',
        ],
      },
    ],
    faqs: [
      {
        q: 'ทำไมประวัติการเทรดไม่ขึ้น',
        a: 'สาเหตุที่พบบ่อยคือตัวกรองช่วงวันที่ไม่ครอบคลุม หรือล็อกอินบัญชีอื่นอยู่',
        a2: 'ให้คลิกขวาในแท็บ Account History แล้วเลือก All History ก่อน ถ้ายังว่างให้ตรวจเลขบัญชีที่มุมขวาล่างว่าตรงกับบัญชีที่เคยเทรดหรือไม่ และตรวจว่าประวัตินั้นเกิดบนเครื่องนี้หรือเครื่องอื่น เพราะ MT4 เก็บประวัติไว้ในเครื่อง ไม่ได้ซิงก์ข้ามเครื่องอัตโนมัติ',
      },
      {
        q: 'ดูค่าสวอปและคอมมิชชันได้จากไหน',
        a: 'ดูได้จากรายละเอียดของแต่ละออเดอร์ในประวัติ หรือจาก Detailed Report ที่แสดงแยกทุกค่า',
        a2: 'ตัวเลขที่ควรจับตาคือถ้าค่าสวอปรวมต่อเดือนเกิน 5% ของกำไรขั้นต้น แปลว่าการถือข้ามคืนกำลังกินผลตอบแทน ให้พิจารณาถือไม้นานขึ้นแต่น้อยไม้ลง หรือเลือกคู่เงินที่มีสวอปถูกกว่า',
      },
      {
        q: 'ประวัติการเทรดเก็บไว้นานแค่ไหน',
        a: 'ขึ้นกับนโยบายของโบรกเกอร์ ส่วนใหญ่เก็บในเซิร์ฟเวอร์ 3-12 เดือน แต่ในเครื่องจะเก็บไว้จนกว่าจะลบโฟลเดอร์ข้อมูล',
        a2: 'ถ้าต้องการเก็บระยะยาว ให้ส่งออกเป็นไฟล์รายเดือนแล้วเก็บไว้เอง เพราะเมื่อโบรกเกอร์ล้างข้อมูลเก่า ประวัติจะหายไปจากแพลตฟอร์ม การเก็บไฟล์ HTML เดือนละหนึ่งไฟล์ใช้พื้นที่ไม่ถึง 1 MB และช่วยให้ย้อนดูผลงานข้ามปีได้',
      },
    ],
  },
  'mt4-chart-no-price': {
    intro: [
      'กราฟว่างหรือหยุดนิ่งมักมาจากการเชื่อมต่อหลุดหรือคู่เงินปิดตลาด ไม่ใช่โปรแกรมเสีย และแก้ได้ในไม่กี่ขั้นตอน',
      'ก่อนสรุปว่าเป็นปัญหา ให้ตรวจสถานะการเชื่อมต่อมุมขวาล่างก่อนเสมอ เพราะเป็นจุดที่บอกสาเหตุได้เร็วที่สุด',
    ],
    sections: [
      {
        heading: 'ตรวจสถานะการเชื่อมต่อก่อน',
        paragraphs: [
          'มุมขวาล่างของหน้าจอแสดงสถานะเชื่อมต่อและตัวเลข ping ถ้าเห็นตัวเลขวิ่งแสดงว่าเชื่อมต่อปกติ ปัญหาอยู่ที่อื่น',
          'ถ้าขึ้น No connection ให้ตรวจอินเทอร์เน็ตแล้วล็อกอินใหม่ผ่าน File > Login to Trade Account ซึ่งแก้ได้ในเกือบทุกกรณี',
        ],
        bullets: [
          'ตัวเลข ping วิ่ง = เชื่อมต่อปกติ',
          'No connection = ต้องล็อกอินใหม่',
          'ตรวจอินเทอร์เน็ตก่อนเสมอ',
          'ปิด VPN ถ้าเชื่อมต่อเซิร์ฟเวอร์ไม่ได้',
        ],
      },
      {
        heading: 'ถ้าเชื่อมต่อปกติแต่กราฟยังว่าง',
        paragraphs: [
          'คลิกขวาที่กราฟแล้วเลือก Refresh เพื่อให้ระบบดึงข้อมูลใหม่ บางครั้งกราฟค้างเพราะข้อมูลเก่าถูกโหลดค้างไว้',
          'ถ้ายังว่าง ให้ตรวจว่าคู่เงินนั้นยังเปิดให้เทรดอยู่หรือไม่ เพราะคู่เงินบางคู่ปิดซื้อขายช่วงสุดสัปดาห์หรือวันหยุดของตลาดนั้น',
        ],
        bullets: [
          'คลิกขวา > Refresh ดึงข้อมูลใหม่',
          'ตรวจว่าเป็นช่วงปิดตลาดหรือไม่',
          'ลองเปลี่ยนไปคู่เงินหลักเพื่อทดสอบ',
          'ปิดแล้วเปิดโปรแกรมใหม่เป็นทางเลือกสุดท้าย',
        ],
      },
      {
        heading: 'กราฟแสดงแต่หยุดนิ่ง',
        paragraphs: [
          'ถ้ากราฟแสดงแท่งเทียนครบแต่ราคาไม่ขยับ ให้ดูคอลัมน์ Time ใน Market Watch ว่าอัปเดตล่าสุดเมื่อไร',
          'กรณีที่พบบ่อยคือตลาดปิดอยู่จริง เช่น ช่วงสุดสัปดาห์ที่ตลาด Forex ปิดตั้งแต่เช้าวันเสาร์จนถึงเช้าวันจันทร์ตามเวลาเซิร์ฟเวอร์',
        ],
        bullets: [
          'คอลัมน์ Time บอกเวลาอัปเดตราคาล่าสุด',
          'Forex ปิดช่วงสุดสัปดาห์เป็นเรื่องปกติ',
          'คู่เงิน Exotic อาจปิดคนละเวลากับคู่หลัก',
          'ถ้าทั้งกระดานนิ่ง ให้ตรวจการเชื่อมต่อ',
        ],
      },
      {
        heading: 'เมื่อไรควรติดต่อโบรกเกอร์',
        paragraphs: [
          'ถ้าเชื่อมต่อปกติ เปลี่ยนคู่เงินแล้วยังว่าง และเป็นช่วงเวลาที่ตลาดเปิดจริง ให้ติดต่อฝ่ายบริการลูกค้าพร้อมแจ้งชื่อเซิร์ฟเวอร์และเวลาที่เกิดปัญหา',
          'ก่อนติดต่อให้ลองลบบันทึกแคชกราฟโดยเปิด Data Folder แล้วลบไฟล์ในโฟลเดอร์ history ของคู่นั้น ซึ่งแก้ปัญหาข้อมูลเสียได้บ่อย',
        ],
        bullets: [
          'แจ้งชื่อเซิร์ฟเวอร์และเวลาที่เกิดปัญหา',
          'ลองลบไฟล์ history ของคู่เงินนั้น',
          'ตรวจว่าบัญชีไม่ได้ถูกจำกัดการเข้าถึง',
          'เก็บภาพหน้าจอไว้ประกอบการแจ้งปัญหา',
        ],
      },
    ],
    faqs: [
      {
        q: 'กราฟ MT4 ว่างแต่ Market Watch มีราคา',
        a: 'แปลว่าเชื่อมต่อปกติแต่กราฟไม่ได้รับข้อมูล ให้กด Refresh ที่กราฟก่อนเป็นอันดับแรก',
        a2: 'ถ้าไม่หาย ให้ปิดกราฟนั้นแล้วเปิดใหม่จาก File > New Chart ซึ่งจะสร้างกราฟใหม่ที่ดึงข้อมูลครบ ถ้ายังว่างอีกให้ตรวจว่ากราฟถูกตั้งค่าเป็น Online หรือไม่ โดยดูที่มุมขวาบนของกราฟ ถ้าไม่มีคำว่า Online แปลว่ากราฟถูกตัดการอัปเดต',
      },
      {
        q: 'ทำไมกราฟหายไปหลายวัน',
        a: 'ส่วนใหญ่เกิดจากไฟล์ประวัติในเครื่องเสียหรือถูกจำกัดจำนวนแท่งที่โหลด',
        a2: 'ให้เปิด File > Open Data Folder แล้วไปที่ history โฟลเดอร์ของเซิร์ฟเวอร์ ลบไฟล์ของคู่เงินนั้นแล้วรีสตาร์ต MT4 ระบบจะดาวน์โหลดใหม่ ซึ่งอาจใช้เวลาราว 1-3 นาที ขึ้นกับความเร็วเน็ตและจำนวนแท่งที่ขอ',
      },
      {
        q: 'กราฟขึ้น Waiting for update ตลอด',
        a: 'หมายถึงรอข้อมูลจากเซิร์ฟเวอร์ ซึ่งมักมาจากการเชื่อมต่อสะดุดหรือคู่นั้นปิดตลาด',
        a2: 'ให้ตรวจสถานะมุมขวาล่างก่อน ถ้าเป็น No connection ให้ล็อกอินใหม่ ถ้าเชื่อมต่อปกติแต่ยังรอ ให้ตรวจว่าเป็นช่วงสุดสัปดาห์หรือไม่ เพราะคู่เงินจะกลับมาไหลอีกครั้งเมื่อตลาดเปิด และบางครั้งต้องรีสตาร์ตโปรแกรมหนึ่งครั้งก่อนข้อมูลจะกลับมา',
      },
    ],
  },
  'mt4-indicator-not-showing': {
    intro: [
      'อินดิเคเตอร์ที่เพิ่มแล้วไม่ขึ้นบนกราฟ ส่วนใหญ่เกิดจากรายการยังโหลดไม่ครบ ตัวอินดิเคเตอร์ถูกซ่อน หรือไฟล์ไม่รองรับบิลด์ปัจจุบัน',
      'การไล่ตรวจตามลำดับ 3 ขั้นตอนช่วยแยกสาเหตุได้ภายใน 2-3 นาที',
    ],
    sections: [
      {
        heading: 'ตรวจว่าอินดิเคเตอร์ถูกเพิ่มจริงหรือไม่',
        paragraphs: [
          'กด Ctrl+I เพื่อดูรายการอินดิเคเตอร์บนกราฟนั้น ถ้าชื่อที่ต้องการไม่อยู่ในรายการ แปลว่าการเพิ่มไม่สำเร็จ ให้ลากจาก Navigator ลงบนกราฟใหม่',
          'ถ้าอยู่ในรายการแต่ไม่เห็นเส้น ให้ตรวจว่าอินดิเคเตอร์นั้นแสดงในหน้าต่างย่อยหรือบนกราฟหลัก เพราะบางตัวจะไปอยู่ด้านล่างจนมองไม่เห็นถ้า Terminal บังอยู่',
        ],
        bullets: [
          'Ctrl+I ตรวจรายการอินดิเคเตอร์บนกราฟ',
          'ถ้าไม่มีชื่อ แปลว่ายังไม่ได้เพิ่ม',
          'อินดิเคเตอร์บางตัวอยู่ในหน้าต่างย่อย',
          'ย่อ Terminal เพื่อให้เห็นหน้าต่างย่อยทั้งหมด',
        ],
      },
      {
        heading: 'ตรวจการตั้งค่าที่ซ่อนเส้นไว้',
        paragraphs: [
          'ในหน้าต่างตั้งค่าของอินดิเคเตอร์ แท็บ Colors มีช่องที่กำหนดให้เส้นบางหรือสีเดียวกับพื้นหลัง ซึ่งทำให้ดูเหมือนไม่แสดง',
          'ให้เปลี่ยนสีเป็นสีที่ตัดกับพื้นหลังและเพิ่มความหนาเป็น 1-2 px ก่อนสรุปว่าไฟล์มีปัญหา',
        ],
        bullets: [
          'ตรวจสีเส้นในแท็บ Colors',
          'ความหนา 1-2 px พอเห็นชัด',
          'ตรวจช่อง Levels ว่าตั้งค่าผิดหรือไม่',
          'กด Reset กลับค่าเริ่มต้นเพื่อทดสอบ',
        ],
      },
      {
        heading: 'กรณีไฟล์อินดิเคเตอร์ไม่รองรับ',
        paragraphs: [
          'อินดิเคเตอร์ที่เขียนขึ้นเองหรือดาวน์โหลดมานานอาจใช้กับบิลด์ใหม่ไม่ได้ อาการคือเพิ่มแล้วไม่มีอะไรเกิดขึ้นหรือขึ้นข้อความ error ในแท็บ Experts',
          'ให้เปิดแท็บ Experts ใน Terminal เพื่อดูข้อความ error ซึ่งจะบอกชื่อไฟล์และสาเหตุ เช่น cannot load หรือ incompatible',
        ],
        bullets: [
          'เปิดแท็บ Experts ดูข้อความ error',
          'ไฟล์ .ex4 เก่าอาจใช้กับบิลด์ใหม่ไม่ได้',
          'ติดต่อผู้พัฒนาเพื่อขอเวอร์ชันที่รองรับ',
          'อย่าอัปเดตแพลตฟอร์มกลางเทรด',
        ],
      },
      {
        heading: 'เมื่อต้องติดตั้งใหม่',
        paragraphs: [
          'ถ้าไฟล์หาย ให้เปิด File > Open Data Folder แล้วไปที่ MQL4 > Indicators ตรวจว่าไฟล์ .ex4 อยู่ที่นั่นจริง จากนั้นรีสตาร์ต MT4',
          'ถ้าต้องติดตั้งใหม่ ให้ปิดโปรแกรมก่อนคัดลอกไฟล์ แล้วเปิดใหม่หนึ่งครั้ง เพื่อให้ระบบสแกนรายการและแสดงใน Navigator',
        ],
        bullets: [
          'ไฟล์ต้องอยู่ใน MQL4 > Indicators',
          'ปิดโปรแกรมก่อนคัดลอกไฟล์',
          'หลังคัดลอกให้รีสตาร์ตหนึ่งครั้ง',
          'สำรองโฟลเดอร์ MQL4 ก่อนอัปเดตแพลตฟอร์ม',
        ],
      },
    ],
    faqs: [
      {
        q: 'เพิ่มอินดิเคเตอร์แล้วไม่มีอะไรเกิดขึ้น',
        a: 'อาจลากไปวางผิดตำแหน่ง หรือไฟล์ไม่รองรับบิลด์ที่ใช้อยู่ ให้ตรวจแท็บ Experts ก่อน',
        a2: 'เปิด Terminal แล้วดูแท็บ Experts ซึ่งจะแสดงข้อความเช่น cannot load indicator ตามด้วยชื่อไฟล์ ถ้ามีข้อความนี้แปลว่าไฟล์มีปัญหา ไม่ใช่การตั้งค่า ถ้าไม่มีข้อความเลย ให้กด Ctrl+I ตรวจว่ารายการมีชื่ออินดิเคเตอร์นั้นอยู่หรือไม่',
      },
      {
        q: 'อินดิเคเตอร์หายหลังอัปเดต MT4',
        a: 'เพราะตัวอัปเดตอาจสร้างโฟลเดอร์ข้อมูลใหม่ ทำให้ไฟล์เดิมไม่ถูกโหลด',
        a2: 'ให้เปิด File > Open Data Folder ดูว่ามีโฟลเดอร์ MQL4 หรือไม่ ถ้าหายไปให้คัดลอกจากสำรองกลับมา ซึ่งเป็นเหตุผลที่ควรสำรองโฟลเดอร์นี้ก่อนอัปเดตทุกครั้ง ไฟล์มีขนาดราว 20-100 MB ขึ้นกับจำนวนที่ติดตั้งไว้',
      },
      {
        q: 'อินดิเคเตอร์ขึ้นแต่เส้นไม่ขยับ',
        a: 'อาจตั้งกรอบเวลาผิด หรืออินดิเคเตอร์คำนวณจากแท่งที่ยังไม่ปิด จึงอัปเดตเฉพาะตอนแท่งจบ',
        a2: 'ให้ตรวจว่ากราฟตั้งเป็น Online และรอให้แท่งปัจจุบันปิดก่อน ถ้าอินดิเคเตอร์ยังนิ่งเกิน 1 ชั่วโมงบนกรอบ H1 แปลว่ามีปัญหา ให้ลบแล้วเพิ่มใหม่ หรือตรวจว่าเครื่องไม่ได้หยุดรับข้อมูลราคา',
      },
    ],
  },
  'mt4-cannot-login': {
    intro: [
      'ล็อกอินไม่ผ่านมีสาเหตุหลักอยู่ไม่กี่อย่าง ตั้งแต่รหัสผ่านผิด เลือกเซิร์ฟเวอร์ไม่ตรง ไปจนถึงบัญชีถูกระงับ',
      'ข้อความแจ้งเตือนของ MT4 บอกสาเหตุได้ค่อนข้างชัด ถ้ารู้วิธีอ่านจะแก้ได้เองในเกือบทุกกรณี',
    ],
    sections: [
      {
        heading: 'อ่านข้อความแจ้งเตือนก่อนแก้',
        paragraphs: [
          'Invalid account หมายถึงเลขบัญชีหรือรหัสผ่านไม่ตรงกับเซิร์ฟเวอร์ที่เลือก ส่วน Invalid server หมายถึงไม่มีเซิร์ฟเวอร์ชื่อนั้นในระบบ',
          'Account disabled คือบัญชีถูกระงับ ซึ่งต่างจากรหัสผิด และ No connection คือเชื่อมต่อเซิร์ฟเวอร์ไม่ได้เลย',
        ],
        bullets: [
          'Invalid account = เลขบัญชีหรือรหัสผิด',
          'Invalid server = ชื่อเซิร์ฟเวอร์ไม่ถูก',
          'Account disabled = บัญชีถูกระงับ',
          'No connection = เชื่อมต่อเซิร์ฟเวอร์ไม่ได้',
        ],
      },
      {
        heading: 'ตรวจข้อมูลให้ตรงกับอีเมล',
        paragraphs: [
          'คัดลอกชื่อเซิร์ฟเวอร์จากอีเมลมาวางเทียบทีละตัวอักษร เพราะปัญหาส่วนใหญ่มาจากเลือกเซิร์ฟเวอร์ผิด ไม่ใช่รหัสผ่านผิด',
          'ตรวจเลขบัญชีว่ากรอกครบ 8 หลักและไม่มีช่องว่างติดมา รวมถึงตรวจว่าได้ใช้รหัสบัญชีซื้อขาย ไม่ใช่รหัสเข้าเว็บไซต์',
        ],
        bullets: [
          'เทียบชื่อเซิร์ฟเวอร์จากอีเมลทีละตัวอักษร',
          'ตรวจว่าเลขบัญชีครบ 8 หลัก',
          'รหัสซื้อขายอาจต่างจากรหัสเว็บ',
          'ปิด Caps Lock และช่องว่างหน้า-หลัง',
        ],
      },
      {
        heading: 'ทดสอบด้วยบัญชีทดลอง',
        paragraphs: [
          'ถ้ามีบัญชีทดลอง ให้ลองล็อกอินบัญชีนั้นก่อน ถ้าล็อกอินได้แสดงว่าอินเทอร์เน็ตและโปรแกรมปกติ ปัญหาอยู่ที่ข้อมูลบัญชีจริง',
          'ถ้าบัญชีทดลองก็ล็อกอินไม่ได้ ให้ตรวจว่าไฟร์วอลล์หรือ VPN กำลังบล็อกการเชื่อมต่อพอร์ตของเซิร์ฟเวอร์',
        ],
        bullets: [
          'ล็อกอินบัญชีทดลองเพื่อแยกสาเหตุ',
          'ปิด VPN แล้วลองใหม่',
          'ตรวจไฟร์วอลล์ว่าไม่ได้บล็อก MT4',
          'ลองเปลี่ยนเครือข่ายถ้าทำได้',
        ],
      },
      {
        heading: 'เมื่อต้องติดต่อโบรกเกอร์',
        paragraphs: [
          'ถ้าตรวจครบแล้วยังไม่ผ่าน ให้ติดต่อโบรกเกอร์พร้อมแจ้งเลขบัญชี ข้อความ error ที่ขึ้น และเวลาที่เกิดปัญหา ซึ่งช่วยให้ตรวจได้เร็วขึ้น',
          'บัญชีทดลองที่ไม่ได้ใช้งานนานหลายสัปดาห์มักถูกปิดอัตโนมัติ กรณีนี้ไม่ใช่รหัสผิด แต่ต้องเปิดบัญชีทดลองใหม่',
        ],
        bullets: [
          'แจ้งเลขบัญชีและข้อความ error',
          'บัญชีทดลองอาจหมดอายุหากไม่ใช้งาน',
          'ขอรีเซ็ตรหัสได้ที่ Client Portal',
          'เก็บภาพหน้าจอ error ไว้',
        ],
      },
    ],
    faqs: [
      {
        q: 'ล็อกอินไม่ผ่านแต่รหัสถูกแน่ ๆ',
        a: 'ให้ตรวจชื่อเซิร์ฟเวอร์ก่อน เพราะกรณีส่วนใหญ่ที่รหัสถูกแต่เข้าไม่ได้ เกิดจากเลือกเซิร์ฟเวอร์ผิด',
        a2: 'วิธีตรวจที่เร็วที่สุดคือเปิดอีเมลของโบรกเกอร์แล้วคัดลอกชื่อเซิร์ฟเวอร์มาวางเทียบทีละตัวอักษร โดยเฉพาะตัวเลขท้าย เช่น Live01 กับ Live02 ถ้าเลือกผิดระบบจะขึ้น Invalid account ทันทีแม้รหัสจะถูกต้อง',
      },
      {
        q: 'บัญชีทดลองล็อกอินไม่ได้เพราะอะไร',
        a: 'สาเหตุที่พบบ่อยคือบัญชีทดลองหมดอายุ เพราะหลายโบรกเกอร์ปิดบัญชีทดลองที่ไม่ได้ใช้งานเกิน 30 วัน',
        a2: 'วิธีตรวจคือดูอีเมลยืนยันตอนสมัครว่ามีวันหมดอายุระบุไว้หรือไม่ ถ้าหมดอายุแล้วต้องสมัครใหม่ ซึ่งใช้เวลาไม่ถึง 5 นาทีและได้เลขบัญชีใหม่ ไม่สามารถใช้เลขเดิมต่อได้',
      },
      {
        q: 'ขึ้น Account disabled ต้องทำอย่างไร',
        a: 'ต้องติดต่อโบรกเกอร์เท่านั้น เพราะเป็นการระงับบัญชีจากฝั่งเซิร์ฟเวอร์ ไม่สามารถแก้ได้จากแพลตฟอร์ม',
        a2: 'สาเหตุที่พบบ่อยคือยังไม่ได้ส่งเอกสารยืนยันตัวตน บัญชีไม่ได้ใช้งานนานเกินกำหนด หรือมีปัญหาด้านความปลอดภัย ให้เตรียมบัตรประชาชนและหลักฐานที่อยู่ไว้พร้อม โดยทั่วไปใช้เวลาตรวจ 1-3 วันทำการ',
      },
    ],
  },
};